// extracted by mini-css-extract-plugin
module.exports = {"oldValue":"PolicyDiffComponent_oldValue__88aT_","newValue":"PolicyDiffComponent_newValue__qGKP3","policyDifferenceBlock":"PolicyDiffComponent_policyDifferenceBlock__1Ut7K"};